import store from "../redux/store";

export const removePhoneNumberFormatting = (phoneNumber) => {
  if (!phoneNumber) return "";
  // keep numbers and plus sign
  return phoneNumber.replace(/[^0-9+]/g, "");
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  phoneNumber = phoneNumber.replace("%2b1", "+1");

  // Remove all non numeric characters
  let cleaned = ("" + phoneNumber).replace(/\D/g, "");

  // Ensure the phone number starts with +1
  if (!cleaned.startsWith("1")) {
    cleaned = "1" + cleaned;
  }

  // Add the plus sign
  cleaned = "+" + cleaned;

  // Extract parts of the phone number
  const country = cleaned.substring(0, 2);
  const area = cleaned.substring(2, 5);
  const local = cleaned.substring(5, 8);
  const number = cleaned.substring(8);

  // Format the phone number
  const formattedNumber = `${country} (${area}) ${local} ${number}`;

  return formattedNumber;
};

export const formatPhoneNumberUsingFormats = (phoneNumber) => {
  if (phoneNumber.length < 5) return phoneNumber;

  // check if phone number includes a-zA-z values
  const hasLetters = phoneNumber.match(/[a-zA-Z]/);
  if (hasLetters) return phoneNumber;

  // Remove all non-digit characters except the plus sign
  const digits = phoneNumber.replace(/[^\d]/g, "");
  if (digits.length < 5) return digits;

  // Extract the country code
  let countryCode = "1"; // Default to US code
  let numberWithoutCode = digits;
  for (let code in phoneFormats) {
    if (digits.startsWith("+" + code) || digits.startsWith(code)) {
      countryCode = code;
      // Remove the country code from the number
      numberWithoutCode = digits.substring(code.length);
      break;
    }
  }

  
  // Get the corresponding format
  const format = phoneFormats[countryCode] ? phoneFormats[countryCode].format : phoneFormats["1"].format;

  // Check if the number is too long
  if (numberWithoutCode.length > format.replace(/[^#]/g, "").length) {
    return digits;
  }


  // Format the phone number according to the format
  let formattedNumber = "";
  let numberIndex = 0;

  for (let i = 0; i < format.length; i++) {
    if (format[i] === "#") {
      if (numberIndex < numberWithoutCode.length) {
        formattedNumber += numberWithoutCode[numberIndex];
        numberIndex++;
      } else {
        formattedNumber += " ";
      }
    } else {
      formattedNumber += format[i];
    }
  }

  return formattedNumber.trim();
};

export const validateExtension = (extension) => {
  const destinations = store.getState().info.destinations;
  if (!destinations || destinations.length === 0) {
    // length should be between 3 and 4
    if (extension.length < 3 || extension.length > 4) {
      return "Extension should be 3-4 characters";
    }
  };

  if (destinations && destinations.length > 0 && destinations.findIndex((destination) => destination.id === extension) === -1) {
    return "Extension is required";
  }

  return "";
}


export const validatePhoneNumber = (formattedNumber) => {
  if (formattedNumber.length < 5) return false;

  // Extract the country code from the formatted number
  let countryCode = "1"; // Default to US code
  for (let code in phoneFormats) {
    if (formattedNumber.startsWith("+" + code)) {
      countryCode = code;
      break;
    }
  }

  // Get the corresponding format
  const format = phoneFormats[countryCode] ? phoneFormats[countryCode].format : phoneFormats["1"].format;
  
  // Build a regex pattern from the format
  let regexPattern = "^";
  for (let i = 0; i < format.length; i++) {
    if (format[i] === "#") {
      regexPattern += "\\d";
    } else {
      regexPattern += format[i].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
  }
  regexPattern += "$";

  const regex = new RegExp(regexPattern);
  
  return regex.test(formattedNumber);
};

const phoneFormats = {
  1: { country: "US/CA", format: "+1 (###) ### ####" },
  44: { country: "GB", format: "+44 #### ######" },
  33: { country: "FR", format: "+33 # ## ## ## ##" },
  49: { country: "DE", format: "+49 ### ### ####" },
  91: { country: "IN", format: "+91 ##### #####" },
  61: { country: "AU", format: "+61 # #### ####" },
  86: { country: "CN", format: "+86 ## #### ####" },
  81: { country: "JP", format: "+81 ## #### ####" },
  // 7: { country: "RU", format: "+7 ### ### ## ##" },
  55: { country: "BR", format: "+55 ## #### ####" },
  972: { country: "IL", format: "+972 ## ### ####" },
  31: { country: "NL", format: "+31 ## ### ####" },
  34: { country: "ES", format: "+34 ### ### ###" },
  39: { country: "IT", format: "+39 ### #######" },
  351: { country: "PT", format: "+351 ## ### ####" },
  352: { country: "LU", format: "+352 ### ####" },
  353: { country: "IE", format: "+353 # #######" },
  354: { country: "IS", format: "+354 ### ####" },
  358: { country: "FI", format: "+358 ## ### ####" },
  370: { country: "LT", format: "+370 ### ## ###" },
  371: { country: "LV", format: "+371 #### ####" },
  372: { country: "EE", format: "+372 ### ####" },
  374: { country: "AM", format: "+374 ## ### ###" },
  375: { country: "BY", format: "+375 ## ### ####" },
  376: { country: "AD", format: "+376 ### ###" },
  377: { country: "MC", format: "+377 ## ### ###" },
  378: { country: "SM", format: "+378 ### ####" },
  380: { country: "UA", format: "+380 ## ### ## ##" },
  381: { country: "RS", format: "+381 ## ### ####" },
  382: { country: "ME", format: "+382 ## ### ####" },
  385: { country: "HR", format: "+385 ## ### ####" },
  386: { country: "SI", format: "+386 ## ### ###" },
  387: { country: "BA", format: "+387 ## ### ###" },
  389: { country: "MK", format: "+389 ## ### ###" },
};
